import { ref, watch } from "vue";
import { useForm } from "vee-validate";

export default function useCustomForm(...args: Parameters<typeof useForm>) {
  const formRef = useForm(...args);
  const currentlyInvalid = ref(false);

  watch(
    () => formRef.errorBag,
    (newErrorBag) => {
      currentlyInvalid.value = !!newErrorBag.value && !!Object.keys(newErrorBag.value).length;
    },
    { deep: true }
  );

  return {
    formRef,
    currentlyInvalid,
  };
}
